import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { CLIENTS_ROLES } from '../../constants/tableTypes'
import { STORE_CLIENT_ROLES } from '../../constants/actionTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
}

const clientsRolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_CLIENT_ROLES:
      return {
        ...state,
        content: action.content,
      }
    default:
      return reducers.dataTable.tableFetchReducer(CLIENTS_ROLES, state, action)
  }
}

export default combineReducers({
  data: clientsRolesReducer,
  tableInfo: tableReducer,
})

export { initialState, clientsRolesReducer }
